import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=2f6f0ed0&scoped=true"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js"
import style0 from "./NotificationDropDown.vue?vue&type=style&index=0&id=2f6f0ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f0ed0",
  null
  
)

export default component.exports